import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { ReactComponent as Add } from "../../Global Icons/ads.svg";
import { addAdsBanners } from "../../Redux/Actions/banner_adsActions";
import { useDispatch, useSelector } from "react-redux";
import AddImage from "../../Global Functions/addImage";
import { viewCountryListPagination } from "../../Redux/Actions/settingsActions";
import toast from "react-hot-toast";
import TextInput from "../../Global Functions/textInput";
import { useNavigate } from "react-router-dom";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";
import SelectInput from "../../Global Functions/selectInput";
import "./addAdsBanner.css";

const AddAdsBanners = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dropdownType = ["ad", "banner", "event"];

  useEffect(() => {
    dispatch(viewCountryListPagination());
  }, [dispatch]);

  const { countryList } = useSelector((state) => state.country);

  const [adsData, setAdsData] = useState({
    title: "",
    type: "",
    start_date: "",
    end_date: "",
    country_id: "",
    is_global: true,
    cover_photo: "",
    file_type: "",
    description: "",
    external_link: "",
  });

  const handleAddChange = (event) => {
    const { name, value } = event.target;

    setAdsData((prev) => {
      let updatedState = { ...prev, [name]: value };
      if (
        name === "start_date" &&
        new Date(updatedState.end_date) < new Date(value)
      ) {
        updatedState.end_date = value;
      }
      return updatedState;
    });
  };

  const validateForm = () => {
    if (!adsData.title?.trim()) {
      toast.error("Title is required");
      return false;
    }
    if (!adsData.type?.trim()) {
      toast.error("Type is required");
      return false;
    }
    if (!adsData.start_date?.trim()) {
      toast.error("Start Date is required");
      return false;
    }
    if (!adsData.end_date?.trim()) {
      toast.error("End Date is required");
      return false;
    }
    if (
      adsData.start_date &&
      adsData.end_date &&
      new Date(adsData.end_date) < new Date(adsData.start_date)
    ) {
      toast.error("End Date cannot be before Start Date");
      return false;
    }
    if (!adsData.country_id?.trim()) {
      toast.error("Country selection is required");
      return false;
    }
    if (!adsData.cover_photo?.trim()) {
      toast.error("Please upload a banner image or video");
      return false;
    }
    if (!adsData.description?.trim()) {
      toast.error("Description is required");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    const fileType = adsData.cover_photo.split(".").pop()?.toLowerCase();
    let fileTypeValue = "";

    if (["jpeg", "jpg", "png", "webp"].includes(fileType)) {
      fileTypeValue = "image";
    } else if (["mp4", "avi"].includes(fileType)) {
      fileTypeValue = "video";
    }

    if (!fileTypeValue) {
      toast.error("Please upload a valid file!");
      return;
    }

    // Create complete payload with file_type
    const payload = { 
      ...adsData, 
      file_type: fileTypeValue 
    };

    try {
      const response = await dispatch(addAdsBanners(payload));
      if (response.statusCode === 200) {
        // Reset form on success
        setAdsData({
          title: "",
          type: "",
          start_date: "",
          end_date: "",
          country_id: "",
          is_global: true,
          cover_photo: "",
          file_type: "",
          description: "",
          external_link: "",
        });
        navigate("/dealsAndOffers");
      } else {
        toast.error(response?.message || "Submission failed");
      }
    } catch (error) {
      toast.error(error?.message || "An error occurred");
    }
  };

  return (
    <MainLayout>
      <div className="addsBanners-container">
        <div className="addsBanners-firstRow">
          <div style={{ display: "flex", alignItems: "center" }}>
            <Add />
            <h1>Add Ads, Banners</h1>
          </div>
          <button
            onClick={() => navigate("/dealsAndOffers")}
            className="button-class"
          >
            View List
          </button>
        </div>
        <div>
          <div className="add_form">
            <TextInput
              label="Title"
              onChange={handleAddChange}
              name="title"
              required={true}
              type="text"
              placeholder="Enter Title"
              value={adsData.title}
            />
            <div>
              <SelectInput
                value={adsData.country_id}
                placeholder="Select an Option"
                onChange={handleAddChange}
                required={true}
                name="country_id"
                label="Select a Country"
                options={
                  Array.isArray(countryList?.data)
                    ? countryList.data.map((country) => ({
                        label: country.country_name,
                        value: country._id,
                      }))
                    : []
                }
              />
            </div>
            <div>
              <SelectInput
                value={adsData.type}
                placeholder="Select an Option"
                label="Type"
                name="type"
                required={true}
                onChange={handleAddChange}
                options={dropdownType?.map((item) => ({
                  label: item.charAt(0).toUpperCase() + item.slice(1),
                  value: item,
                }))}
              />
            </div>
            <TextInput
              type="date"
              label="Start Date"
              name="start_date"
              value={adsData.start_date}
              onChange={handleAddChange}
              min={new Date().toISOString().split("T")[0]}
              max={adsData.end_date || undefined}
              required
            />
            <TextInput
              type="date"
              label="End Date"
              name="end_date"
              value={adsData.end_date}
              onChange={handleAddChange}
              min={adsData.start_date || new Date().toISOString().split("T")[0]}
              required
            />
            <TextInput
              label="Description"
              onChange={handleAddChange}
              value={adsData.description}
              type="text"
              required={true}
              name="description"
            />
            <TextInput
              label="External link"
              onChange={handleAddChange}
              value={adsData.external_link}
              type="text"
              required={false}
              name="external_link"
            />
            <div>
              <span className="span-class">
                Upload Banner<span style={{ color: "red" }}>*</span>
              </span>
              <input
                accept=".jpg,.jpeg,.png,.webp,.mp4,.avi"
                onChange={async (event) => {
                  const uploadedFile = event.target.files[0];

                  if (uploadedFile) {
                    const allowedTypes = [
                      "image/jpeg",
                      "image/jpg",
                      "image/png",
                      "image/webp",
                      "video/mp4",
                      "video/x-msvideo",
                    ];
                    if (!allowedTypes.includes(uploadedFile.type)) {
                      toast.error(
                        "Only JPG, JPEG, PNG, WebP, MP4, and AVI files are allowed!"
                      );
                      event.target.value = "";
                      return;
                    }
                    const responseUrl = await AddImage(uploadedFile);
                    if (responseUrl) {
                      setAdsData((prevData) => ({
                        ...prevData,
                        cover_photo: responseUrl,
                      }));
                    }
                  }
                  event.target.value = "";
                }}
                id="image"
                hidden
                type="file"
                className="input-class"
              />
              <label className="label-class-image" htmlFor="image">
                Click to Upload Image<span style={{ color: "red" }}>*</span>
              </label>
              <ImageShowerModalGlobal
                keyField="cover_photo"
                setState={setAdsData}
                state={adsData}
                file={adsData.cover_photo}
              />
            </div>
            <div className="flex-end span2">
              <button className="button-class" onClick={handleSubmit}>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddAdsBanners;